const companyActionTypes = {
    
    START_GET_COMPANY: 'START_GET_COMPANY',
    GET_COMPANY_SUCCESS: 'GET_COMPANY_SUCCESS',
    GET_COMPANY_FAILURE: 'GET_COMPANY_FAILURE',
    
}

export default companyActionTypes;